// extracted by mini-css-extract-plugin
export default {"container":"y5tSWX","visible":"Y_oly7","hidden":"F84nrS","close-button":"RAbgcA","closeButton":"RAbgcA"};